// @ts-nocheck
export function parseOptionalInt(raw, label) {
  const text = String(raw ?? '').trim();
  if (!text) return undefined;
  if (!/^-?\d+$/.test(text)) throw new Error(`${label} must be an integer`);
  return Number(text);
}

const PLAN_BOOL_KEYS = [
  'whatsapp',
  'web',
  'tiktok',
  'comment_automation',
  'followup_enabled',
  'faq_enabled',
  'owner_copilot',
  'customer_ai',
  'instagram_dm',
  'facebook_dm',
  'content_management',
];

export function planDraftFromCatalog(catalog) {
  /** @type {Record<string, any>} */
  const rows = {};
  for (const plan of catalog?.plans || []) {
    rows[plan.plan_id] = {
      intended_price_usd: plan.intended_price_usd,
      included_messages: plan.included_messages,
      faq_capacity: plan.faq_capacity,
      additional_seats: plan.additional_seats == null ? '' : plan.additional_seats,
      additional_seats_unlimited: plan.additional_seats == null || plan.additional_seats_unlimited === true,
      included_team_seats: plan.included_team_seats != null
        ? plan.included_team_seats
        : (plan.additional_seats == null ? '' : Number(plan.additional_seats) + 1),
      included_team_unlimited: plan.included_team_seats == null
        && (plan.additional_seats == null || plan.additional_seats_unlimited === true),
      whatsapp: Boolean(plan.whatsapp),
      web: Boolean(plan.web),
      tiktok: Boolean(plan.tiktok),
      comment_automation: Boolean(plan.comment_automation),
      followup_enabled: plan.followup_enabled !== false,
      faq_enabled: plan.faq_enabled !== false,
      owner_copilot: plan.owner_copilot !== false,
      customer_ai: plan.customer_ai !== false,
      instagram_dm: plan.instagram_dm !== false,
      facebook_dm: plan.facebook_dm !== false,
      content_management: plan.content_management !== false,
    };
  }
  return rows;
}

export function planChangesFromDraft(plans) {
  /** @type {Record<string, any>} */
  const out = {};
  for (const [planId, row] of Object.entries(plans || {})) {
    const legacyUnlimited = Boolean(row.additional_seats_unlimited);
    const legacySeats = legacyUnlimited ? null : parseOptionalInt(row.additional_seats, `${planId} extra seats`);
    const usesIncluded = row.included_team_unlimited !== undefined || row.included_team_seats !== undefined;
    const includedUnlimited = Boolean(row.included_team_unlimited);
    const includedRaw = includedUnlimited
      ? null
      : parseOptionalInt(row.included_team_seats, `${planId} included team users`);
    const included = usesIncluded ? (includedUnlimited ? null : (includedRaw ?? 1)) : null;
    /** @type {Record<string, any>} */
    const item = {
      intended_price_usd: Number(row.intended_price_usd),
      included_messages: parseOptionalInt(row.included_messages, `${planId} messages`),
      faq_capacity: parseOptionalInt(row.faq_capacity, `${planId} ready answers`),
      additional_seats: usesIncluded
        ? (included == null ? null : Math.max(0, included - 1))
        : (legacyUnlimited ? null : (legacySeats ?? 0)),
    };
    if (usesIncluded) item.included_team_seats = included;
    for (const key of PLAN_BOOL_KEYS) item[key] = Boolean(row[key]);
    out[planId] = item;
  }
  return out;
}

const FREE_NOTE_FIELDS = [
  'free_message_renewal',
  'knowledge_line_budget',
  'services_products_line_budget',
  'content_line_definition',
  'message_topup_prices',
  'credit_to_message_conversion',
];

export function freeDraftFromCatalog(catalog) {
  const free = catalog?.free || {};
  const src = free.configured && typeof free.configured === 'object' ? free.configured : {};
  /** @type {Record<string, string>} */
  const configured = {};
  for (const field of FREE_NOTE_FIELDS) configured[field] = src[field] == null ? '' : String(src[field]);
  return {
    included_messages: free.included_messages == null ? '' : String(free.included_messages),
    included_team_seats: free.included_team_seats == null || free.included_team_seats === ''
      ? '1'
      : String(free.included_team_seats),
    signup_trial_messages: free.signup_trial_messages == null ? '' : String(free.signup_trial_messages),
    signup_trial_days: free.signup_trial_days == null ? '' : String(free.signup_trial_days),
    configured,
  };
}

export { FREE_NOTE_FIELDS, PLAN_BOOL_KEYS };
